/* (ASYNC) */
export const FETCH_DASHBOARD_INIT = 'FETCH_DASHBOARD_INIT';
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS';
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE';

export const FETCH_DASHBOARD_DATE_INIT = 'FETCH_DASHBOARD_DATE_INIT';
export const FETCH_DASHBOARD_DATE_SUCCESS = 'FETCH_DASHBOARD_DATE_SUCCESS';
export const FETCH_DASHBOARD_DATE_FAILURE = ' FETCH_DASHBOARD_DATE_FAILURE';

export const DASHBOARD_CHANGE_MENU_COLLAPSE_STATE = 'DASHBOARD_CHANGE_MENU_COLLAPSE_STATE';

export const RESET_DASHBOARD = 'RESET_DASHBOARD';

// Change the language of the app
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
/* Config behavior action type */
export const BEHAVIOR_CONFIG = 'BEHAVIOR_CONFIG';

export const SET_TOUR_VIEWED_SUCCESS = 'SET_TOUR_VIEWED_SUCCESS';

export const FETCH_TASK_MANAGER_INDICATORS_INIT = 'FETCH_TASK_MANAGER_INDICATORS_INIT';
export const FETCH_TASK_MANAGER_INDICATORS_SUCCESS = 'FETCH_TASK_MANAGER_INDICATORS_SUCCESS';
export const FETCH_TASK_MANAGER_INDICATORS_FAILURE = ' FETCH_TASK_MANAGER_INDICATORS_FAILURE';



// WEBPACK FOOTER //
// ./source/client/actions/dashboard/types.js